module.exports = __webpack_public_path__ + "img/aParty_091123_G.e4fdd430.jpg";